//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { request } from "../../requests";
import 'jsGrid';
export default {
  name: "SitesTable",
  props: ['context', 'context_id'],

  mounted() {
    jQuery(this.$refs.table).jsGrid({
      width: '100%',
      fields: [{
        type: "text",
        name: "business_name",
        title: "Property / Business Name"
      }, {
        type: "text",
        name: "address",
        title: "Address"
      }, {
        type: "text",
        name: "type",
        title: "Type"
      }, {
        type: 'control',
        width: '18%',
        editButton: false,
        deleteButton: false,

        itemTemplate(value, item) {
          const $buttons = $('<div>').attr({
            role: 'group',
            class: 'btn-group'
          });

          if (!item.perm_settings.disable_downloads) {
            const $iconDwn = $('<i>').attr({
              class: 'fas fa-arrow-down'
            });
            const $btnDwn = $('<button>').attr({
              class: 'btn btn-default',
              disabled: !item.sf_share_link ? true : false
            }).click(function (e) {
              e.stopPropagation();
              if (item.sf_share_link) window.open(item.sf_share_link);
            }).append($iconDwn).append(' Download');
            $buttons.append($btnDwn);
          }

          if (!item.perm_settings.disable_uploads) {
            const $iconUp = $('<i>').attr({
              class: 'fas fa-arrow-up'
            });
            const $btnUp = $('<button>').attr({
              class: 'btn btn-default',
              disabled: !item.sf_request_link ? true : false
            }).click(function (e) {
              e.stopPropagation();
              if (item.sf_request_link) window.open(item.sf_request_link);
            }).append($iconUp).append(' Upload');
            $buttons.append($btnUp);
          }

          return $buttons;
        }

      }],
      height: 'auto',
      editing: false,
      heading: true,
      sorting: true,
      autoload: true,
      filtering: false,
      selecting: true,
      editButton: false,
      noDataContent: 'No Sites Found',
      // Pagination
      paging: true,
      pageSize: 5,
      pageLoading: true,
      controller: {
        loadData: this.onLoadData.bind(this)
      },
      rowClick: this.onDataClicked.bind(this)
    });
  },

  methods: {
    onLoadData(filter = null) {
      let data = filter;
      const url = `/tables/sites/${this.context}/${this.context_id}`;
      return request({
        url,
        data,
        method: 'GET',
        spinner: false
      }).then(responseData => {
        return {
          data: responseData.data,
          itemsCount: responseData.count
        };
      });
    },

    onDataClicked(data) {
      window.location.href = data.item.url;
    }

  }
};